import React from "react";
import { Box } from "@mui/material";

import { tokens } from "../../theme/galleryTheme";

/** Centred page-width container with the standard side gutters. */
export function PageContainer({ children, sx, ...rest }) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: tokens.layout.maxWidth,
        mx: "auto",
        px: tokens.layout.gutter,
        boxSizing: "border-box",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}


export default function Section({ tone = "paper", labelledBy, children, sx, containerSx, ...rest }) {
  return (
    <Box
      component="section"
      aria-labelledby={labelledBy}
      sx={{
        bgcolor: tone === "ivory" ? tokens.color.ivory : tokens.color.paper,
        py: tokens.layout.sectionY,
        ...sx,
      }}
      {...rest}
    >
      <PageContainer sx={containerSx}>{children}</PageContainer>
    </Box>
  );
}
